import gql from 'graphql-tag';

export const ListRafflesQuery = gql`
  {
    Raffles {
      _id
      name
      logo
    }
  }
`;

export const GetRaffleQuery = gql`
  query($id: String!) {
    Raffle(filter:{_id: $id}) {
      _id
      name
      logo
    }
  }
`;

export const UpdateRaffleMutation = gql`
  mutation ($id: String!, $update: JSON) {
    updateRaffle(filter: {_id: $id}, update: $update) {
      _id
    }
  }
`;

export const CreateRaffleMutation = gql`
  mutation($record: JSON) {
    createRaffle(record: $record) {
      _id
    }
  }
`;
